var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 8,
    viewBox: "0 0 21 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58178 0.526116C1.16932 0.565484 0.866388 0.931603 0.905176 1.34387C0.943963 1.75613 1.30978 2.05842 1.72225 2.01906L1.58178 0.526116ZM19.2769 2.32249C19.6888 2.36664 20.0589 2.06861 20.1037 1.65683C20.1484 1.24505 19.8508 0.875451 19.439 0.831304L19.2769 2.32249ZM1.72225 2.01906C3.6264 1.83732 4.93228 2.11371 5.84399 2.567C6.75126 3.01808 7.3299 3.67493 7.73009 4.36452C8.13828 5.06789 8.35236 5.78651 8.54071 6.38473C8.62514 6.65289 8.72613 6.97248 8.8581 7.2074C8.92438 7.32538 9.04405 7.50829 9.24906 7.63739C9.49908 7.79483 9.79311 7.82113 10.0628 7.72588L9.56486 6.31189C9.71252 6.25974 9.89877 6.27287 10.05 6.36812C10.1562 6.43501 10.1862 6.50669 10.1665 6.47165C10.1265 6.40053 10.0708 6.24692 9.97183 5.93263C9.79342 5.36595 9.53421 4.4827 9.02807 3.61056C8.51395 2.72464 7.73724 1.83234 6.51365 1.22399C5.29449 0.617848 3.694 0.324518 1.58178 0.526116L1.72225 2.01906ZM10.0628 7.72588C10.2645 7.65466 10.4166 7.53252 10.5212 7.43167C10.6293 7.32744 10.7248 7.20847 10.8075 7.09513C10.9694 6.87343 11.1442 6.58614 11.3176 6.30624C11.6798 5.722 12.117 5.03557 12.7312 4.38756C13.9227 3.13058 15.8375 1.95383 19.2769 2.32249L19.439 0.831304C15.5052 0.409644 13.1361 1.78147 11.6429 3.35687C10.9148 4.12504 10.4095 4.92575 10.0426 5.51769C9.85162 5.82589 9.71527 6.04896 9.59613 6.21214C9.53838 6.29124 9.50085 6.33334 9.48061 6.35285C9.45686 6.37574 9.48523 6.34001 9.56486 6.31189L10.0628 7.72588Z",
    fill: "#323844"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBird);
export default __webpack_public_path__ + "static/media/Bird.a1e52c6f3d0781627d9ff3ca8fec904f.svg";
export { ForwardRef as ReactComponent };